import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default function (params) {
  const { data, exec, isRequestSuccessed, isLoading } = useRequest({
    url: '',
    name: 'DEVICE_OEE_MONITOR_GET',
  });
  useEffect(() => {
    if (params && JSON.stringify(params) !== '{}') {
      let url = `/api/device/oee/monitor`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?'
        } else {
          url += '&'
        };
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || {}, isRequestSuccessed, isLoading];
}